import { Route, Redirect } from 'react-router-dom'

import { useSelector } from "react-redux";

const RedirectRoute = ({ component: Component, ...rest }) => {

    const userLogin = useSelector((state) => state.userLogin);
    const { success } = userLogin;

    return (
        <Route
            {...rest}
            render={props => success ? (
                <Redirect to='/courses' />
            ) : (
                <Component {...props} />
            )}
        />
    )
}

export default RedirectRoute